import React, { Component } from "react";

import tick from "../../svg/tick-circle.svg";

class SuccessMessage extends Component {
  /**
   * this class have the code of the error popup message
   * and it displayes the generic error code for everything
   */

  render() {
    const { message } = this.props;
    return (
      <div className="popup-back">
        <div className="popup-body-container">
          <div className="">
            <img className="popup-img" src={tick} alt="" />
          </div>
          <div className="popup-title">Success</div>
          <div className="popup-description">{message}</div>
          <input type="button" className="popup-btn" value="Ok" onClick={this.props.onCloseClick.bind(this)} />
        </div>
      </div>
    );
  }
}

export default SuccessMessage;



// WEBPACK FOOTER //
// ./src/components/CommonComponents/SuccessMessage.js